import { render, staticRenderFns } from "./FacturaFormDetalleProductoServicio.vue?vue&type=template&id=6531e5a7&scoped=true"
import script from "./FacturaFormDetalleProductoServicio.vue?vue&type=script&lang=js"
export * from "./FacturaFormDetalleProductoServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531e5a7",
  null
  
)

export default component.exports